<script type="text/javascript">
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import { writable, get } from 'svelte/store';
	import DownloadButton from "../DownloadButton/DownloadButton.svelte";
	import DownloadHelper from "../../Helpers/DownloadHelper";
	import GeoHelper from '../../Helpers/GeoHelper';
	import VesselHistoryStore from "../VesselHistory/Store";

</script>

<MenuItem>
	<DownloadButton filename="vessel-history-results-json.json" text="Download Results (GeoJSON)" content={DownloadHelper.vesselHistoryPointsUrl} />
	<DownloadButton filename="vessel-history-results-csv.csv" text="Download Results (CSV)" content={DownloadHelper.vesselHistoryPointsCSVUrl} />
</MenuItem>
